<si-about aboutTitle="About" appName="Point UI" [licenseInfo]="{ title: 'License' }" icon="assets/images/simpl-logo.svg"
  appName="POINT UI OVERVIEW" [subheading]="['app version: v0.0.1', '&copy; Siemens 2021']"
  [imprintLink]="{ title: 'Corporate information', href: 'http://www.siemens.com/corporate-information' }"
  [privacyLink]="{ title: 'Privacy policy', href: 'http://www.siemens.com/privacy-notice' }"
  [termsLink]="{ title: 'Terms of use', href: 'http://www.siemens.com/terms-of-use' }"></si-about>
